import React, { useRef } from 'react'
import classNames from 'classnames'
import { NavLink, withRouter } from 'react-router-dom'

import style from './Tab.module.css'

function Tab({
  to,
  value,
  className,
  isActiveByDefault,
  match,
  location,
  isSelected,
  onSelect,
  text,
  disabled,
  theme,
  type,
  isHorizontal,
  testId
}) {
  const tabRef = useRef(null)
  const handleKeyDown = (event) => {
    if (event.key.startsWith('Arrow')) {
      event.preventDefault()
      const tabsContainer = tabRef.current.parentNode
      const isVertical = tabsContainer.getAttribute('data-vertical') === 'true'
      const tabs = Array.from(tabRef.current.parentNode.children)
      if (tabs.length > 1) {
        const currentIndex = tabs.findIndex((tab) => tab === tabRef.current)
        let nextIndex

        if (
          isVertical &&
          (event.key === 'ArrowUp' || event.key === 'ArrowDown')
        ) {
          nextIndex =
            event.key === 'ArrowUp'
              ? currentIndex === 0
                ? tabs.length - 1
                : currentIndex - 1
              : currentIndex === tabs.length - 1
              ? 0
              : currentIndex + 1
        } else if (
          !isVertical &&
          (event.key === 'ArrowLeft' || event.key === 'ArrowRight')
        ) {
          nextIndex =
            event.key === 'ArrowLeft'
              ? currentIndex === 0
                ? tabs.length - 1
                : currentIndex - 1
              : currentIndex === tabs.length - 1
              ? 0
              : currentIndex + 1
        }

        const nextTab = tabs[nextIndex]?.querySelector(to ? 'a' : 'div')
        nextTab?.focus()
      }
    }
  }
  const handleOnClick = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      onSelect(value)
    }
  }
  return (
    <div
      onKeyDown={handleKeyDown}
      tabIndex={'-1'}
      ref={tabRef}
      data-testid={testId}
      className={classNames(
        style.custom_tabs,
        type === 'primary-tab'
          ? style.primary_container
          : type === 'secondary-tab'
          ? style.secondary_container
          : style.container,
        isHorizontal && style.horizontal_tabs,
        className
      )}
    >
      {to ? (
        <NavLink
          to={to}
          role='tab'
          aria-selected={to === location.pathname ? 'true' : 'false'}
          aria-disabled={disabled}
          className={classNames(
            type === 'primary-tab'
              ? style.primary
              : type === 'secondary-tab'
              ? style.secondary
              : style.link,
            theme && style[theme],
            disabled && style.disabled
          )}
          exact
          activeClassName={
            type === 'primary-tab'
              ? style.primary_active
              : type === 'secondary-tab'
              ? style.secondary_active
              : style.link_active
          }
          isActive={
            isActiveByDefault
              ? (onOwnPath) => !!(onOwnPath || match.url === location.pathname)
              : null
          }
        >
          {text}
        </NavLink>
      ) : (
        <div
          role='tab'
          className={classNames(
            type === 'primary-tab'
              ? style.primary
              : type === 'secondary-tab'
              ? style.secondary
              : style.link,
            isSelected &&
              (type === 'primary-tab'
                ? style.primary_active
                : type === 'secondary-tab'
                ? style.secondary_active
                : style.link_active),
            disabled && style.disabled,
            theme && style[theme]
          )}
          aria-selected={isSelected ? 'true' : 'false'}
          aria-disabled={disabled}
          tabIndex={'-1'}
          onClick={() => onSelect(value)}
          onKeyDown={handleOnClick}
        >
          {text}
        </div>
      )}
    </div>
  )
}

export default withRouter(Tab)
